import type { ReactNode } from "react";
import { AppIcon, type AppIconName } from "./AppIcons";

export type AppShellProps = {
  active: "query" | "calculator";
  mainId: string;
  title: string;
  subtitle: string;
  children: ReactNode;
  status?: ReactNode;
};

const navigation: ReadonlyArray<{ id: AppShellProps["active"]; href: string; label: string; icon: AppIconName }> = [
  { id: "query", href: "/", label: "HS 查询", icon: "search" },
  { id: "calculator", href: "/calculator", label: "税费计算", icon: "calculator" },
];

function Navigation({ active }: { active: AppShellProps["active"] }) {
  return (
    <nav className="app-sidebar-nav" aria-label="工作台导航">
      {navigation.map((item) => item.id === active ? (
        <span className="app-nav-current" aria-current="page" key={item.id}>
          <AppIcon name={item.icon} size={18} />
          <span>{item.label}</span>
        </span>
      ) : (
        <a href={item.href} key={item.id}>
          <AppIcon name={item.icon} size={18} />
          <span>{item.label}</span>
        </a>
      ))}
    </nav>
  );
}

export function AppShell({ active, mainId, title, subtitle, children, status }: AppShellProps) {
  return (
    <div className="app-shell">
      <a className="skip-link" href={`#${mainId}`}>跳到主要内容</a>
      <aside className="app-sidebar" aria-label="RiskCustoms 工作台">
        <div className="app-sidebar-brand">
          <a className="app-brand-mark" href="/" aria-label="RiskCustoms 首页"><AppIcon name="brand" size={22} /></a>
          <div className="app-brand-copy">
            <h1>{title}</h1>
            <p><span>{subtitle.split(" · ")[0]}</span>{subtitle.includes(" · ") ? ` · ${subtitle.slice(subtitle.indexOf(" · ") + 3)}` : null}</p>
          </div>
        </div>
        <Navigation active={active} />
        <div className="app-sidebar-footer">
          <AppIcon name="database" size={16} />
          <span>规则与数据工作台</span>
        </div>
      </aside>

      <div className="app-content">
        {status ? <div className="app-status-bar">{status}</div> : null}
        <main className="app-main" id={mainId}>{children}</main>
      </div>
    </div>
  );
}
